<template>
  <div>
    <PageAllow
      controller="OrderRulers"
      :action="
        $route.query.mode && $route.query.mode == 'view'
          ? 'expressFeeView'
          : 'saveExpressFee'
      "
    />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(isNew ? "CRUD.newInfo" : "CRUD.editInfo", [
              $t("MaterialOrderRule.expressFee.title"),
            ])
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $permission.checkAccountExpired().then(() => {
                    $router.replace('/material-order-rules?type=' + ruleType);
                  })
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <v-container>
            <ValidationObserver ref="observer">
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.Fields.rule_name") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.Fields.rule_name')"
                    rules="required"
                  >
                    <v-text-field
                      single-line
                      v-model="order_rule.name"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.name }}
                </v-col>
              </v-row>
              <!-- 运费规则描述 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.memo") + $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('MaterialOrderRule.expressFee.memo')"
                    rules="required"
                  >
                    <v-textarea
                      single-line
                      auto-grow
                      outlined
                      v-model="order_rule.memo"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'name')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-textarea>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ order_rule.memo }}
                </v-col>
              </v-row>
              <!-- 活动范围 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.range") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7">
                  <span v-if="savable">
                    <v-radio-group row v-model="rangeFlag" class="mt-0">
                      <v-radio
                        v-for="stat in rangeTypeItems"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                    <!-- 按分组 -->
                    <v-btn
                      v-if="rangeFlag == 1"
                      color="primary"
                      class="my-1 mr-3"
                      outlined
                      @click="districts_one_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.application_districts"),
                        ])
                      }}
                    </v-btn>
                    <!-- 按区域 -->
                    <v-btn
                      v-if="rangeFlag == 2"
                      color="primary"
                      class="my-1 mr-3"
                      outlined
                      @click="cities_dialog = true"
                    >
                      {{
                        $t("CRUD.chooseInfo", [
                          $t("MaterialOrderRule.Fields.cities_districts"),
                        ])
                      }}
                    </v-btn>
                  </span>
                  <span v-else>
                    {{ rangeFlag | rangeTypesText }}
                  </span>
                  <br />
                  <!-- 已选分组 -->
                  <v-data-table
                    v-if="rangeFlag == 1"
                    :headers="districtHeaders"
                    :items="districts_one"
                    :loading="districtsLoading"
                    multi-sort
                    class="elevation-1 px-4 pt-2"
                    disable-pagination
                    hide-default-footer
                    fixed-header
                  >
                    <template v-slot:header.actions="{ header }">
                      {{ header.text }}
                      <v-icon x-small>fa-sliders-h</v-icon>
                    </template>
                    <template v-slot:item.actions="{ item }">
                      <v-btn
                        small
                        text
                        class="danger--text pa-0"
                        @click="
                          districts_one.splice(
                            districts_one.findIndex(
                              (district) => district.id == item.id
                            ),
                            1
                          )
                        "
                      >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                    </template>
                  </v-data-table>
                  <!-- 已选区域 -->
                  <v-card class="mx-4 mb-4" v-if="rangeFlag == 2">
                    <v-progress-linear
                      :indeterminate="loading"
                    ></v-progress-linear>
                    <!-- 已选择 -->
                    <v-card-title>
                      {{ $t("MaterialOrderRule.expressFee.choosed_cities") }}
                    </v-card-title>
                    <v-divider />
                    <v-treeview
                      class="py-2"
                      :items="confirmCities"
                      item-key="city_id"
                      item-text="name"
                      item-children="cities"
                      item-disabled="false"
                      open-all
                    >
                      <template v-slot:label="{ item }">
                        {{ item.name }}
                      </template>
                    </v-treeview>
                  </v-card>
                </v-col>
              </v-row>
              <!-- 启用包邮 -->
              <v-row align="center">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.free_money") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col>
                      <v-checkbox
                        v-model="freeFlag"
                        true-value="1"
                        false-value="0"
                        :hint="$t('MaterialOrderRule.expressFee.free_hint')"
                        persistent-hint
                        small
                      ></v-checkbox>
                    </v-col>
                    <v-col>
                      <v-row v-if="freeFlag == 1" class="mt-3">
                        <span class="text-h6">≥</span>
                        <v-text-field
                          v-model="conditions.free_money"
                          single-line
                          dense
                          hide-details
                          type="number"
                          :prefix="$t('Global.money')"
                          min="0"
                          style="margin: auto"
                        />
                      </v-row>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span>
                    {{
                      freeFlag == 1
                        ? "≥ " + conditions.free_money
                        : $t("MaterialOrderRule.expressFee.free_money_off")
                    }}
                  </span>
                </v-col>
              </v-row>
              <!-- 品类 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.category_match_flg") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <v-row>
                    <v-col>
                      <span v-if="savable">
                        <v-radio-group
                          row
                          v-model="categoryMatchFlg"
                          class="mt-0"
                        >
                          <v-radio
                            v-for="stat in $consts.orderRule
                              .category_match_types"
                            :key="stat.value"
                            :label="`${stat.text}`"
                            :value="stat.value"
                          ></v-radio>
                        </v-radio-group>
                      </span>
                    </v-col>
                  </v-row>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  <span>
                    {{ categoryMatchFlg | categoryMatchTypesText }}
                  </span>
                </v-col>
              </v-row>

              <!-- 运费计算依据 -->
              <v-row v-if="!categoryMatchFlg">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.pay_type") +
                    $t("Global.colon")
                  }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7">
                  <v-row class="pl-3" v-if="savable">
                    <v-radio-group row v-model="pay_type">
                      <v-radio
                        v-for="stat in payTypeItems"
                        class="mt-n2"
                        :key="stat.value"
                        :label="`${stat.text}`"
                        :value="stat.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-row>
                  <span v-else>
                    {{ pay_type | expressPayTypesText }}
                  </span>
                  <div class="mt-3">
                    <!-- 按照金额计算 -->
                    <v-data-table
                      v-if="pay_type == 1"
                      :headers="expressHeadersOne"
                      :items="expressItemsOne"
                      :loading="expressDetailsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:item.actions="{ index }">
                        <v-btn
                          v-if="index != 0"
                          small
                          text
                          class="danger--text pa-0"
                          @click="express_details_one.splice(index, 1)"
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:item.step="{ index }">
                        {{ index + 1 }}
                      </template>
                      <template v-slot:item.order_fee="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.order_fee"
                          dense
                          :prefix="$t('Global.money')"
                          @blur="
                            item.order_fee = $numberFormatter.formatMoney(
                              item.order_fee
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.order_fee }}
                        </span>
                      </template>
                      <template v-slot:item.express_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.express_price"
                          dense
                          :prefix="$t('Global.money')"
                          @blur="
                            item.express_price = $numberFormatter.formatMoney(
                              item.express_price
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.express_price }}
                        </span>
                      </template>
                    </v-data-table>
                    <!-- 按照重量或数量计算 -->
                    <v-data-table
                      v-else-if="
                        pay_type == 2 || pay_type == 3 || pay_type == 5
                      "
                      :headers="expressHeadersTwo"
                      :items="expressItemsTwo"
                      :loading="expressDetailsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:header.start="{ header }">
                        <span v-if="pay_type == 5">
                          {{ $t("MaterialOrderRule.Fields.startPcs") }}≤
                        </span>
                        <span v-else> {{ header.text }}≤ </span>
                      </template>
                      <template v-slot:item.start="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.start"
                          @blur="
                            item.start = $numberFormatter.formatMoney(
                              item.start
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          dense
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ item.start }}
                        </span>
                      </template>
                      <template v-slot:item.express_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.express_price"
                          dense
                          :prefix="$t('Global.money')"
                          @blur="
                            item.express_price = $numberFormatter.formatMoney(
                              item.express_price
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.express_price }}
                        </span>
                      </template>
                      <template v-slot:item.add_num="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.add_num"
                          @blur="
                            item.add_num = $numberFormatter.formatMoney(
                              item.add_num
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          dense
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ item.add_num }}
                        </span>
                      </template>
                      <template v-slot:item.add_price="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.add_price"
                          dense
                          :prefix="$t('Global.money')"
                          @blur="
                            item.add_price = $numberFormatter.formatMoney(
                              item.add_price
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.add_price }}
                        </span>
                      </template>
                    </v-data-table>
                    <v-data-table
                      v-else
                      :headers="expressHeadersThree"
                      :items="expressItemsThree"
                      :loading="expressDetailsLoading"
                      multi-sort
                      class="elevation-1 px-4 pt-2"
                      disable-pagination
                      hide-default-footer
                      fixed-header
                    >
                      <template v-slot:header.actions="{ header }">
                        {{ header.text }}
                        <v-icon x-small>fa-sliders-h</v-icon>
                      </template>
                      <template v-slot:header.order_fee="{ header }">
                        {{ header.text }}
                        <br />
                        <span class="red--text caption">{{
                          $t("MaterialOrderRule.Fields.start_order_fee_hint")
                        }}</span>
                      </template>
                      <template v-slot:item.step="{ index }">
                        {{ index + 1 }}
                      </template>

                      <template v-slot:item.actions="{ index }">
                        <v-btn
                          v-if="index != 0"
                          small
                          text
                          class="danger--text pa-0"
                          @click="express_details_three.splice(index, 1)"
                        >
                          <v-icon>fa-times</v-icon>
                        </v-btn>
                      </template>
                      <template v-slot:item.order_fee="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.order_fee"
                          dense
                          :prefix="$t('Global.money')"
                          @blur="
                            item.order_fee = $numberFormatter.formatMoney(
                              item.order_fee
                            )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          type="number"
                          min="0"
                          style="max-width: 80px; margin-left: auto"
                        />
                        <span v-else>
                          {{ $t("Global.money") + item.order_fee }}
                        </span>
                      </template>
                      <template v-slot:item.prcent="{ item }">
                        <v-text-field
                          v-if="savable"
                          v-model="item.prcent"
                          @blur="
                            item.prcent =
                              $numberFormatter.formatWithDotNoMoreThan(
                                item.prcent,
                                2
                              )
                          "
                          :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                          dense
                          type="number"
                          min="0"
                          suffix="%"
                          style="max-width: 80px; margin: auto"
                        />

                        <span v-else>
                          {{ item.prcent + $t("Global.rate") }}
                        </span>
                      </template>
                    </v-data-table>
                    <span v-if="savable">
                      <br />
                      <v-btn
                        v-if="expressFlag == 1 && pay_type == 1"
                        color="primary"
                        class="my-1 mr-3"
                        outlined
                        @click="addExpressDetail()"
                      >
                        {{ $t("MaterialOrderRule.Fields.add_express_detail") }}
                      </v-btn>
                      <v-btn
                        v-if="expressFlag == 1 && pay_type == 4"
                        color="primary"
                        class="my-1 mr-3"
                        outlined
                        @click="addOrderFeeExpressDetail()"
                      >
                        {{ $t("MaterialOrderRule.Fields.add_express_detail") }}
                      </v-btn>
                    </span>
                  </div>
                </v-col>
              </v-row>
              <!-- 启用阶梯运费 -->
              <v-row
                align="center"
                v-if="(pay_type == 1 || pay_type == 4) && !categoryMatchFlg"
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    $t("MaterialOrderRule.expressFee.express_details") +
                    $t("Global.colon")
                  }}
                </v-col>
                <v-col cols="9" md="7" v-if="savable" class="pt-0">
                  <v-checkbox
                    v-model="expressFlag"
                    true-value="1"
                    false-value="0"
                    persistent-hint
                    :hint="$t('MaterialOrderRule.expressFee.express_hint')"
                    small
                    dense
                  ></v-checkbox>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    expressFlag == 1
                      ? $t("MaterialOrderRule.expressFee.express_details_on")
                      : $t("MaterialOrderRule.expressFee.express_details_off")
                  }}
                </v-col>
              </v-row>
              <!-- 按商品分类运费计算依据 -->
              <span v-if="categoryMatchFlg">
                <span v-for="(item, index) in category_codes" :key="index">
                  <v-row>
                    <v-col cols="3"> </v-col>
                    <v-col cols="9" md="7">
                      <!-- 选择商品分类多选 -->
                      <v-row>
                        <v-btn
                          v-if="categoryMatchFlg && savable"
                          color="primary"
                          class="my-2 ml-3 mt-5"
                          outlined
                          @click.stop="
                            category_dialog = true;
                            currentIndex = index;
                            currentCategories = item.categories;
                          "
                        >
                          {{ $t("MaterialOrderRule.Fields.category_express") }}
                        </v-btn>
                      </v-row>
                    </v-col>
                  </v-row>
                  <v-row v-if="item.categories.length">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MaterialOrderRule.expressFee.choosed_Category") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-chip
                        v-for="(detail, index) in item.categories"
                        small
                        label
                        outlined
                        :key="index"
                        color="primary"
                        :class="(index > 0) ? 'ml-2' : ''"
                        style="font-size: 16px"
                       >
                        {{ detail.name }}
                        <v-btn
                          v-if="savable"
                          x-small
                          text
                          class="danger--text pa-0"
                          @click="
                            item.categories.splice(
                              item.categories.findIndex(
                                (category) => category.id == detail.id
                              ),
                              1
                            );
                            categoriesSelected.splice(
                              categoriesSelected.findIndex(
                                (category) => category == detail.id
                              ),
                              1
                            );
                          "
                        >
                        <v-icon>fa-times</v-icon>
                      </v-btn>
                      </v-chip>
<!--                      <span-->
<!--                        class="my-1 mr-3 mt-4"-->
<!--                        v-for="(detail, index) in item.categories"-->
<!--                        :key="index"-->
<!--                        :style="savable ? 'font-size: 16px' : 'font-size: 14px'"-->
<!--                        >-->
<!--                      </span>-->
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MaterialOrderRule.expressFee.pay_type") +
                        (index + 1) +
                        $t("Global.colon")
                      }}
                      <Required :show="savable" :mode="mode" />
                    </v-col>
                    <v-col cols="9" md="7">
                      <v-row class="pl-3" v-if="savable">
                        <v-radio-group row v-model="item.pay_type">
                          <v-radio
                            v-for="stat in payTypeItems.filter(
                              (item) =>
                                item.value == 1 ||
                                item.value == 2 ||
                                item.value == 3
                            )"
                            class="mt-n2"
                            :key="stat.value"
                            :label="`${stat.text}`"
                            :value="stat.value"
                          ></v-radio>
                        </v-radio-group>
                      </v-row>
                      <span v-else>
                        {{ item.pay_type | expressPayTypesText }}
                      </span>
                      <div class="mt-3">
                        <!-- 按照金额计算 -->
                        <v-data-table
                          v-if="item.pay_type == 1"
                          :headers="expressHeadersOne"
                          :items="item.expressItemsOne"
                          :loading="expressDetailsLoading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:item.actions="{ index }">
                            <v-btn
                              v-if="index != 0"
                              small
                              text
                              class="danger--text pa-0"
                              @click="item.expressItemsOne.splice(index, 1)"
                            >
                              <v-icon>fa-times</v-icon>
                            </v-btn>
                          </template>
                          <template v-slot:item.step="{ index }">
                            {{ index + 1 }}
                          </template>
                          <template v-slot:item.order_fee="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.order_fee"
                              dense
                              :prefix="$t('Global.money')"
                              @blur="
                                item.order_fee = $numberFormatter.formatMoney(
                                  item.order_fee
                                )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") + item.order_fee }}
                            </span>
                          </template>
                          <template v-slot:item.express_price="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.express_price"
                              dense
                              :prefix="$t('Global.money')"
                              @blur="
                                item.express_price =
                                  $numberFormatter.formatMoney(
                                    item.express_price
                                  )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") + item.express_price }}
                            </span>
                          </template>
                        </v-data-table>
                        <!-- 按照重量或数量计算 -->
                        <v-data-table
                          v-else
                          :headers="item.expressHeadersTwo"
                          :items="item.expressItemsTwo"
                          :loading="expressDetailsLoading"
                          multi-sort
                          class="elevation-1 px-4 pt-2"
                          disable-pagination
                          hide-default-footer
                          fixed-header
                        >
                          <template v-slot:header.actions="{ header }">
                            {{ header.text }}
                            <v-icon x-small>fa-sliders-h</v-icon>
                          </template>
                          <template v-slot:header.start="{ header }">
                            {{ header.text }}≤
                          </template>
                          <template v-slot:item.start="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.start"
                              @blur="
                                item.start = $numberFormatter.formatMoney(
                                  item.start
                                )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              dense
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ item.start }}
                            </span>
                          </template>
                          <template v-slot:item.express_price="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.express_price"
                              dense
                              :prefix="$t('Global.money')"
                              @blur="
                                item.express_price =
                                  $numberFormatter.formatMoney(
                                    item.express_price
                                  )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") + item.express_price }}
                            </span>
                          </template>
                          <template v-slot:item.add_num="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.add_num"
                              @blur="
                                item.add_num = $numberFormatter.formatMoney(
                                  item.add_num
                                )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              dense
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ item.add_num }}
                            </span>
                          </template>
                          <template v-slot:item.add_price="{ item }">
                            <v-text-field
                              v-if="savable"
                              v-model="item.add_price"
                              dense
                              :prefix="$t('Global.money')"
                              @blur="
                                item.add_price = $numberFormatter.formatMoney(
                                  item.add_price
                                )
                              "
                              :hint="$t('MaterialOrderRule.Fields.hintTwoDot')"
                              type="number"
                              min="0"
                              style="max-width: 80px; margin-left: auto"
                            />
                            <span v-else>
                              {{ $t("Global.money") + item.add_price }}
                            </span>
                          </template>
                        </v-data-table>
                        <span v-if="savable">
                          <br />
                          <v-btn
                            v-if="item.expressFlag == 1 && item.pay_type == 1"
                            color="primary"
                            class="my-1 mr-3"
                            outlined
                            @click="
                              currentIndex = index;
                              addExpressDetail();
                            "
                          >
                            {{ $t("MaterialOrderRule.Fields.add_express_detail") }}
                          </v-btn>
                        </span>
                      </div>
                    </v-col>
                  </v-row>
                  <!-- 启用阶梯运费 -->
                  <v-row align="center" v-if="item.pay_type == 1">
                    <v-col cols="3" class="font-weight-bold text-right">
                      {{
                        $t("MaterialOrderRule.expressFee.express_details") +
                        $t("Global.colon")
                      }}
                    </v-col>
                    <v-col cols="7" v-if="savable" class="pt-0">
                      <v-checkbox
                        v-model="item.expressFlag"
                        true-value="1"
                        false-value="0"
                        persistent-hint
                        :hint="$t('MaterialOrderRule.expressFee.express_hint')"
                        small
                        dense
                      ></v-checkbox>
                    </v-col>
                    <v-col cols="9" md="7" v-else>
                      {{
                        item.expressFlag == 1
                          ? $t(
                              "MaterialOrderRule.expressFee.express_details_on"
                            )
                          : $t(
                              "MaterialOrderRule.expressFee.express_details_off"
                            )
                      }}
                    </v-col>
                  </v-row>
                  <!-- 添加运费计算依据按钮 -->
                  <v-row v-if="savable && index == category_codes.length - 1">
                    <v-col cols="3"></v-col>
                    <v-col cols="9" md="7">
                      <v-btn
                        color="primary"
                        class="ms-1"
                        outlined
                        @click.stop="addCategoryExpressDetail()"
                      >
                        {{
                          $t(
                            "MaterialOrderRule.expressFee.addCategoryMatchDetail",
                            [index + 2]
                          )
                        }}
                      </v-btn></v-col
                    >
                  </v-row>
                </span>
              </span>
            </ValidationObserver>
          </v-container>
        </v-card-text>
      </v-card>
      <v-sheet class="page-opts">
        <v-card>
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-btn
                  outlined
                  color="secondary"
                  class="elevation-1"
                  block
                  @click="
                    $permission.checkAccountExpired().then(() => {
                      $router.replace('/material-order-rules?type=' + ruleType);
                    })
                  "
                >
                  <v-icon small class="pe-1">fa-times</v-icon>
                  {{
                    $t("CRUD.backToList", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  isView &&
                  $permission.permissionAllow('OrderRulers', 'saveExpressFee')
                "
              >
                <v-btn
                  color="accent"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="toEdit = true"
                >
                  <v-icon small class="pe-1">fa-pencil-alt</v-icon>
                  {{
                    $t("CRUD.editInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'saveExpressFee')
                "
              >
                <v-btn
                  color="success"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="submit()"
                >
                  <v-icon small class="pe-1">fa-save</v-icon>
                  {{
                    $t("CRUD.saveInfo", [$t("MaterialOrderRule.ObjectName")])
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
        <v-card class="mt-4" v-if="!isNew">
          <v-card-title>
            <v-row dense>
              <v-col cols="12">
                <v-row dense align="center">
                  <span class="text-button">{{
                    $t("MaterialOrderRule.Fields.status")
                  }}</span>
                  <v-spacer></v-spacer>
                  <v-chip small label color="gray" text-color="black"
                    >{{ order_rule.status | orderRuleStatusText }}
                  </v-chip>
                </v-row>
              </v-col>
              <!-- <v-col cols="12">
                <v-btn color="primary" class="elevation-1 my-1" block>
                  <span class="mx-2">
                    {{ order_rule.status | orderRuleStatusText }}
                  </span>
                </v-btn>
              </v-col> -->
              <v-col
                cols="12"
                v-if="
                  savable &&
                  $permission.permissionAllow('OrderRulers', 'updateStatus')
                "
              >
                <v-btn
                  v-if="order_rule.status"
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="changeStatus()"
                >
                  {{ $t("MaterialOrderRule.Fields.stop_use") }}
                </v-btn>
                <v-btn
                  v-else
                  outlined
                  color="primary"
                  class="elevation-1"
                  block
                  :disabled="loading && !order_rule.id"
                  @click="useRuleDialog = true"
                >
                  {{ $t("MaterialOrderRule.Fields.start_use") }}
                </v-btn>
              </v-col>
            </v-row>
          </v-card-title>
        </v-card>
      </v-sheet>
      <DialogDistricts
        v-model="districts_one_dialog"
        :districtSelected="districts_one"
        @confirm="districts_one = $event"
      />

      <DialogAlert
        v-model="useRuleDialog"
        :message="$t('MaterialOrderRule.Messages.useRule')"
        useConfirm
        persistent
        @confirm="changeStatus(true)"
      />
      <DialogAlert
        v-model="isLeaveDialog"
        :message="alertMessage"
        persistent
        useConfirm
        @confirm="confirmLeave = true"
      />
      <v-dialog
        persistent
        v-model="cities_dialog"
        width="800px"
        max-height="600px"
      >
        <v-card>
          <v-card-title>
            <span>
              {{ $t("MaterialOrderRule.expressFee.choose_area") }}
            </span>
            <v-spacer></v-spacer>
            <v-tooltip disabled>
              <template v-slot:activator="{ on, attrs }">
                <v-icon v-bind="attrs" v-on="on" @click="cities_dialog = false"
                  >fa-times
                </v-icon>
              </template>
            </v-tooltip>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text height="600px">
            <v-row class="overflow-auto">
              <v-col cols="5">
                <v-card class="mx-4 mb-4 flat">
                  <v-progress-linear
                    :indeterminate="loading"
                  ></v-progress-linear>
                  <!-- 可选择 -->
                  <v-card-title>
                    {{ $t("MaterialOrderRule.expressFee.enable_cities") }}
                  </v-card-title>
                  <v-divider />
                  <div class="overflow-auto">
                    <v-treeview
                      class="py-2 overflow-hidden"
                      v-model="selection"
                      :items="getCities"
                      selected-color="primary"
                      item-children="cities"
                      item-key="city_id"
                      item-text="name"
                      item-disabled="false"
                      selectable
                      return-object
                    >
                      <!-- <template v-slot:label="{ item }">
                    {{ item.name }}
                  </template> -->
                    </v-treeview>
                  </div>
                </v-card>
              </v-col>
              <v-col cols="2" class="text-center">
                <v-btn
                  v-if="rangeFlag == 2"
                  color="primary"
                  class="my-1 mr-3 text-align-center"
                  outlined
                  @click="add()"
                >
                  {{ $t("MaterialOrderRule.Fields.add") }}
                </v-btn>
              </v-col>
              <v-col cols="5" class="overflow-hidden">
                <v-card class="mx-4 mb-4" height="100%">
                  <v-progress-linear
                    :indeterminate="loading"
                  ></v-progress-linear>
                  <!-- 已选择 -->
                  <v-card-title>
                    {{ $t("MaterialOrderRule.expressFee.choosed_cities") }}
                  </v-card-title>
                  <v-divider />
                  <v-treeview
                    class="py-2"
                    :items="choosedCities"
                    item-key="city_id"
                    item-text="name"
                    item-disabled="false"
                    item-children="cities"
                    open-all
                  >
                    <template v-slot:label="{ item }">
                      {{ item.name }}
                      <v-icon
                        small
                        color="accent"
                        class="px-1 py-4 me-1"
                        @click="cut(item.city_id)"
                        >fa-trash-alt
                      </v-icon>
                    </template>
                  </v-treeview>
                </v-card>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" outlined @click="cities_dialog = false">{{
              $t("$vuetify.close")
            }}</v-btn>
            <v-btn
              color="accent"
              @click="
                confirmCities = choosedCities;
                cities_dialog = false;
              "
              >{{ $t("CRUD.save") }}</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
      <DialogCategories
        v-model="category_dialog"
        :categorySelected="currentCategories"
        :disabled="categoriesSelected"
        @confirm="addCategories($event)"
      />
    </v-sheet>
  </div>
</template>
<script>
import i18n from "@/i18n";
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import Breadcrumbs from "@/components/Breadcrumbs";
import Required from "@/components/plugins/Required";
import Consts from "@/consts.js";
import Cities from "@/api/cities.js";
import DialogDistricts from "@/components/plugins/DialogDistricts";
import DialogAlert from "@/components/plugins/DialogAlert";
import { ValidationObserver, ValidationProvider } from "vee-validate";
import OrderRules from "@/api/order_rules";
import DialogCategories from "@/components/plugins/DialogCategories";

const defaultexpressDetailOne = [
  {
    order_fee: 0,
    express_price: 0,
  },
];
const defaultexpressDetailTwo = [
  {
    start: 0,
    express_price: 0,
    add_num: 0,
    add_price: 0,
  },
];
const defaultexpressDetailThree = [
  {
    order_fee: 0,
    prcent: 0,
  },
];
const defaultCategoryExpress = [
  {
    pay_type: 1,
    expressFlag: 0,
    categories: [],
    expressItemsOne: [
      {
        order_fee: 0,
        express_price: 0,
      },
    ],
    expressItemsTwo: [
      {
        start: 0,
        express_price: 0,
        add_num: 0,
        add_price: 0,
      },
    ],
  },
];
export default {
  components: {
    PageAllow,
    Breadcrumbs,
    Required,
    DialogDistricts,
    DialogAlert,
    ValidationObserver,
    ValidationProvider,
    DialogCategories,
  },

  computed: {
    items() {
      return [
        {
          text: i18n.t("Nav.home"),
          disabled: false,
          href: "/home",
        },
        {
          text: i18n.t("Nav.materialManagement"),
          disabled: false,
          href: "/materials",
        },
        {
          text: i18n.t("Nav.materialOrderRules"),
          disabled: true,
          href: "/material-order-rules",
        },
      ];
    },
    isNew() {
      return this.mode == "new";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isView() {
      return this.mode == "view";
    },
    ruleType() {
      return this.$route.query.type;
    },
    districtHeaders() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.district_code"),
          align: "start",
          sortable: false,
          value: "number",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.district_name"),
          align: "start",
          sortable: false,
          value: "name",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 按金额计算时的表头
    expressHeadersOne() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.step"),
          align: "start",
          sortable: false,
          value: "step",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.start_money"),
          align: "end",
          sortable: false,
          value: "order_fee",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.express_price"),
          align: "end",
          sortable: false,
          value: "express_price",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 按数量和重量计算时的表头
    expressHeadersTwo() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.start"),
          align: "start",
          sortable: false,
          value: "start",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.express_price"),
          align: "start",
          sortable: false,
          value: "express_price",
        },
      ];
      if (this.pay_type == 2 || this.pay_type == 5) {
        headers.push({
          text: i18n.t("MaterialOrderRule.Fields.add_num"),
          align: "start",
          sortable: false,
          value: "add_num",
        });
      } else if (this.pay_type == 3) {
        headers.push({
          text: i18n.t("MaterialOrderRule.Fields.add_num2"),
          align: "start",
          sortable: false,
          value: "add_num",
        });
      }
      headers.push({
        text: i18n.t("MaterialOrderRule.Fields.add_price"),
        align: "start",
        sortable: false,
        value: "add_price",
      });
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },
    // 按订单金额百分比计算时的表头
    expressHeadersThree() {
      var headers = [
        {
          text: i18n.t("MaterialOrderRule.Fields.step"),
          align: "start",
          sortable: false,
          value: "step",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.start_order_fee"),
          align: "end",
          sortable: false,
          value: "order_fee",
        },
        {
          text: i18n.t("MaterialOrderRule.Fields.percent"),
          align: "center",
          sortable: false,
          value: "prcent",
        },
      ];
      if (this.savable) {
        headers.push({
          text: i18n.t("TableHeaders.actions"),
          align: "start",
          sortable: false,
          value: "actions",
        });
      }
      return headers;
    },

    expressItemsOne() {
      return this.express_details_one;
    },
    expressItemsTwo() {
      return this.express_details_two;
    },
    expressItemsThree() {
      return this.express_details_three;
    },
    payTypeItems() {
      return Consts.orderRule.pay_types;
    },
    rangeTypeItems() {
      return Consts.orderRule.range_types;
    },

    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    mode: "",
    choosedMaterials: [], //每次选中的商品
    order_rule: {},
    conditions: {},
    serverErrors: [],
    districts: [],
    districtsLoading: false,
    useRuleDialog: false,
    freeFlag: "0",
    categoryMatchFlg: 0,
    pay_type: 1,
    expressFlag: "0",
    expressDetailsLoading: false,
    // const newArr = JSON.parse(JSON.stringify(defaultexpressDetailOne))
    express_details_one: JSON.parse(JSON.stringify(defaultexpressDetailOne)), //当pay_type为1按照金额计算运费时
    express_details_two: JSON.parse(JSON.stringify(defaultexpressDetailTwo)), //当pay_type为2、3按照数量和重量计算运费时
    express_details_three: JSON.parse(
      JSON.stringify(defaultexpressDetailThree)
    ), //当pay_type为4按照订单金额百分比计算运费时

    rangeFlag: 1,
    getCities: [], //所有省市区
    cities_dialog: false,
    selection: [], //被选择的城市
    choosedCities: [], //被选择的城市
    confirmCities: [], //确认的被选择的城市
    districts_one: [], //range_type为1时的活动范围
    districts_two: [], //range_type为2时的活动范围
    districts_one_dialog: false,
    isLeave: false,
    isLeaveDialog: false,
    alertMessage: "",
    confirmLeave: false,
    toPage: "",
    toEdit: false,
    category_codes: JSON.parse(JSON.stringify(defaultCategoryExpress)),
    category_dialog: false,
    currentIndex: null,
    currentCategories: [],
    categoriesSelected: [],
  }),

  mounted() {
    if (this.$route.params.id == 0) {
      this.mode = "new";
    } else {
      this.mode = this.$route.query.mode ? this.$route.query.mode : "view";
      this.getOrderRuleFromAPI(this.$route.params.id);
    }
    // 获取省市
    Cities.cities().then(
      function (response) {
        if (response.data.status.isOK()) {
          this.getCities = JSON.parse(
            JSON.stringify(response.data.cities.cities)
          );
        }
      }.bind(this)
    );
  },

  methods: {
    getOrderRuleFromAPI(id) {
      OrderRules.fetchOne(id, { type: this.ruleType }).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.order_rule = response.data.order_ruler;
            this.conditions = response.data.order_ruler.conditions;
            this.pay_type = this.conditions.pay_type;
            this.rangeFlag = this.order_rule.range_flg;
            this.categoryMatchFlg = this.order_rule.category_match_flg;

            // 判断接口传递的range_flg
            if (this.order_rule.range_flg == 1) {
              this.districts_one =
                response.data.order_ruler.districts &&
                response.data.order_ruler.districts.length
                  ? response.data.order_ruler.districts
                  : [];
            } else {
              this.districts_two = this.order_rule.districts;
            }

            if (this.conditions.free_money && this.conditions.free_money > 0) {
              this.freeFlag = "1";
            }
            // 按商品分类
            if (this.categoryMatchFlg == 1) {
              var category_codes = [];
              var ids = [];
              this.conditions.category_details.forEach((item) => {
                category_codes.push({
                  pay_type: item.pay_type,
                  categories: item.categories,
                  category_group_code: item.category_group_code,
                  expressItemsOne:
                    item.pay_type == 1
                      ? item.express_details
                      : [{ order_fee: 0, express_price: 0 }],
                  expressItemsTwo:
                    item.pay_type == 1
                      ? [
                          {
                            start: 0,
                            express_price: 0,
                            add_num: 0,
                            add_price: 0,
                          },
                        ]
                      : item.express_details,
                  expressFlag:
                    item.pay_type == 1 && item.express_details.length > 1
                      ? "1"
                      : "0",
                });
                item.categories.forEach((detail) => {
                  ids.push(detail.id);
                });
              });
              this.categoriesSelected = ids;
              this.category_codes = category_codes;
            } else {
              if (this.conditions.pay_type == 1) {
                this.express_details_one = this.conditions.express_details;
                this.express_details_two = [
                  { start: 0, express_price: 0, add_num: 0, add_price: 0 },
                ];
                this.express_details_three = [{ order_fee: 0, prcent: 0 }];
              } else if (
                this.conditions.pay_type == 2 ||
                this.conditions.pay_type == 3 ||this.conditions.pay_type == 5
              ) {
                this.express_details_two = this.conditions.express_details;
                this.express_details_one = [{ order_fee: 0, express_price: 0 }];
                this.express_details_three = [{ order_fee: 0, prcent: 0 }];
              } else {
                this.express_details_two = [
                  { start: 0, express_price: 0, add_num: 0, add_price: 0 },
                ];
                this.express_details_one = [{ order_fee: 0, express_price: 0 }];
                this.express_details_three =
                  this.conditions.express_details.map((detail) => {
                    var prcent = detail.prcent;
                    detail.prcent = this.$numberFormatter.formatWithDot(
                      prcent * 100,
                      2
                    );
                    return detail;
                  });
              }
              if (
                (this.conditions.pay_type == 1 ||
                  this.conditions.pay_type == 4) &&
                this.conditions.express_details.length > 1
              ) {
                this.expressFlag = "1";
              }
            }
          }
        }.bind(this)
      );
    },
    submit() {
      this.$store.dispatch("fullscreenLoading");
      this.serverErrors = []; //重置远端错误提示
      this.$refs.observer.validate().then(
        async function (result) {
          if (result) {
            var submit_data = {};

            var districts_id = [];
            if (this.rangeFlag == 1) {
              districts_id = this.districts_one.map((district) => {
                return district.id;
              });
            } else {
              this.confirmCities.forEach((district) => {
                if (district.cities) {
                  district.cities.forEach((district) => {
                    districts_id.push(district.city_id);
                  });
                } else {
                  districts_id.push(district.city_id);
                }
              });
            }
            //整理提交数据
            submit_data = Object.assign({}, submit_data, {
              memo: this.order_rule.memo, //运费描述
              range_flg: this.rangeFlag, //活动范围类型标志
              free_money: this.conditions.free_money
                ? this.conditions.free_money
                : 0,
              district_ids: districts_id, //组别
              category_match_flg: this.categoryMatchFlg, //分类
            });
            //判断是新建还是编辑
            if (this.mode == "edit" || this.order_rule.id) {
              submit_data = Object.assign({}, submit_data, {
                id: this.order_rule.id
                  ? this.order_rule.id
                  : this.$route.params.id,
              });
            }
            if (this.categoryMatchFlg == 1) {
              var category_details = [];
              this.category_codes.forEach((item) => {
                if (item.pay_type == 1) {
                  if (item.expressItemsOne[0].order_fee > 0) {
                    category_details.push({
                      category_codes: item.categories.length
                        ? item.categories.map((detail) => detail.code)
                        : [],
                      category_group_code:
                        this.mode == "edit" || this.order_rule.id
                          ? item.category_group_code
                          : "",
                      pay_type: item.pay_type,
                      express_details:
                        item.pay_type == 1
                          ? item.expressItemsOne
                          : item.expressItemsTwo,
                    });
                  }
                } else {
                  if (item.expressItemsTwo[0].start > 0) {
                    category_details.push({
                      category_codes: item.categories.length
                        ? item.categories.map((detail) => detail.code)
                        : [],
                      category_group_code:
                        this.mode == "edit" || this.order_rule.id
                          ? item.category_group_code
                          : "",
                      pay_type: item.pay_type,
                      express_details:
                        item.pay_type == 1
                          ? item.expressItemsOne
                          : item.expressItemsTwo,
                    });
                  }
                }
              });
              submit_data = Object.assign({}, submit_data, {
                category_details: category_details,
              });
            } else {
              //整理适用的分组和商品
              var express_details = [];
              if (this.pay_type == 1) {
                express_details = this.express_details_one.map((material) => {
                  return material;
                });
              } else if (
                this.pay_type == 2 ||
                this.pay_type == 3 ||
                this.pay_type == 5
              ) {
                express_details = this.express_details_two.map((material) => {
                  return material;
                });
              } else {
                this.express_details_three.forEach((material) => {
                  var prcent = material.prcent;
                  express_details.push(
                    Object.assign({}, material, {
                      prcent: this.$numberFormatter.formatWithDot(
                        prcent / 100,
                        4
                      ),
                    })
                  );
                });
              }
              submit_data = Object.assign({}, submit_data, {
                pay_type: this.pay_type, //运费计算依据
                express_details: express_details,
              });
            }
            //接口提交保存
            OrderRules.save(
              this.ruleType,
              Object.assign({}, submit_data, {
                name: this.order_rule.name,
              })
            )
              .then(
                function (response) {
                  if (response.data.status.isOK()) {
                    this.order_rule = response.data.order_ruler;
                    if (this.order_rule.conditions.pay_type == 4) {
                      this.express_details_three =
                        this.order_rule.conditions.express_details.map(
                          (detail) => {
                            var prcent = detail.prcent;
                            detail.prcent = this.$numberFormatter.formatWithDot(
                              prcent * 100,
                              2
                            );
                            return detail;
                          }
                        );
                    }

                    this.$snackbar.success(
                      i18n.t("MaterialOrderRule.Messages.saveSuccess")
                    );

                    if (!this.order_rule.status) {
                      this.useRuleDialog = true;
                    }
                    if (this.isNew) {
                      this.mode = "edit";
                    }
                  } else if (
                    response.data.error &&
                    response.data.error.data &&
                    "ERR333" == response.data.error.code
                  ) {
                    this.serverErrors = response.data.error.data;
                  }
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              )
              .catch(
                function () {
                  this.$store.dispatch("fullscreenLoadingStop");
                }.bind(this)
              );
          } else {
            this.$store.dispatch("fullscreenLoadingStop");
          }
        }.bind(this)
      );
    },
    changeStatus(backToList) {
      OrderRules.changeStatus(this.order_rule.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            if (backToList) {
              this.confirmLeave = true;
              this.$router.replace(
                "/material-order-rules?type=" + this.ruleType
              );
            } else {
              this.getOrderRuleFromAPI(this.order_rule.id);
            }
          }
        }.bind(this)
      );
    },
    addExpressDetail() {
      if (this.categoryMatchFlg == 1) {
        this.category_codes[this.currentIndex].expressItemsOne.push({
          order_fee: 0,
          express_price: 0,
        });
      } else {
        this.express_details_one.push({ order_fee: 0, express_price: 0 });
      }
    },
    addOrderFeeExpressDetail() {
      this.express_details_three.push({ order_fee: 0, prcent: 0 });
    },
    add() {
      this.choosedCities = this.buildTree(this.selection);
    },
    buildTree(list) {
      // 获取父节点id
      var parent_ids = [];
      list.forEach((item) => {
        if (parent_ids.indexOf(item.parent_city_id) === -1) {
          parent_ids.push(item.parent_city_id);
        }
      });
      var parents = [];
      var getCities = JSON.parse(JSON.stringify(this.getCities));
      parents = getCities.filter((f) => {
        return parent_ids.includes(f.city_id);
      });

      parents.forEach((detail) => {
        var cities = [];
        list.forEach((item) => {
          if (detail.city_id == item.parent_city_id) {
            cities.push(item);
          }
        });
        detail.cities = cities;
      });

      return parents;
    },
    cut(id) {
      this.choosedCities.forEach((detail) => {
        if (detail.city_id == id) {
          this.choosedCities.splice(
            this.choosedCities.findIndex((city) => {
              return city.city_id == id;
            }),
            1
          );
        } else {
          detail.cities.forEach((item) => {
            if (item.city_id == id) {
              detail.cities.splice(
                detail.cities.findIndex((city) => {
                  return city.city_id == id;
                }),
                1
              );
            }
          });
        }
        if (detail.cities && detail.cities.length == 0) {
          this.choosedCities.splice(
            this.choosedCities.findIndex((item) => {
              return item.city_id == detail.city_id;
            }),
            1
          );
        }
      });
    },
    addCategories(data) {
      this.category_codes[this.currentIndex].categories = data;
      var ids = [];
      this.category_codes.forEach((item) => {
        item.categories.forEach((detail) => {
          ids.push(detail.id);
        });
      });
      this.categoriesSelected = ids;
    },
    addCategoryExpressDetail() {
      this.category_codes.push(
        JSON.parse(JSON.stringify(defaultCategoryExpress))[0]
      );
    },
  },

  watch: {
    category_codes: {
      deep: true,
      handler() {
        this.category_codes.forEach((detail) => {
          if (detail.expressFlag == 0 && detail.expressItemsOne.length > 1) {
            detail.expressItemsOne.splice(1);
          }
          var headers = [
            {
              text: i18n.t("MaterialOrderRule.Fields.start"),
              align: "start",
              sortable: false,
              value: "start",
            },
            {
              text: i18n.t("MaterialOrderRule.Fields.express_price"),
              align: "start",
              sortable: false,
              value: "express_price",
            },
          ];
          if (detail.pay_type == 2) {
            headers.push({
              text: i18n.t("MaterialOrderRule.Fields.add_num"),
              align: "start",
              sortable: false,
              value: "add_num",
            });
          } else if (detail.pay_type == 3) {
            headers.push({
              text: i18n.t("MaterialOrderRule.Fields.add_num2"),
              align: "start",
              sortable: false,
              value: "add_num",
            });
          }
          headers.push({
            text: i18n.t("MaterialOrderRule.Fields.add_price"),
            align: "start",
            sortable: false,
            value: "add_price",
          });
          if (this.savable) {
            headers.push({
              text: i18n.t("TableHeaders.actions"),
              align: "start",
              sortable: false,
              value: "actions",
            });
          }
          detail.expressHeadersTwo = headers;
        });
      },
    },
    districts_two: {
      deep: true,
      handler() {
        var cities = JSON.parse(JSON.stringify(this.getCities));
        var districts = [];
        cities.forEach((detail) => {
          detail.cities.forEach((city) => {
            if (
              this.districts_two &&
              this.districts_two.indexOf(city.city_id) > -1
            ) {
              districts.push(city);
            }
          });
        });
        this.confirmCities = this.buildTree(districts);
        this.choosedCities = this.buildTree(districts);
        this.selection = this.buildTree(districts);
      },
    },
    getCities: {
      deep: true,
      handler() {
        if (this.mode == "edit" || this.mode == "view") {
          var cities = JSON.parse(JSON.stringify(this.getCities));
          var districts = [];
          cities.forEach((detail) => {
            detail.cities.forEach((city) => {
              if (
                this.districts_two &&
                this.districts_two.indexOf(city.city_id) > -1
              ) {
                districts.push(city);
              }
            });
          });
          this.confirmCities = this.buildTree(districts);
          this.choosedCities = this.buildTree(districts);
          this.selection = this.buildTree(districts);
        }
      },
    },
    expressFlag: {
      handler() {
        if (this.expressFlag == 0) {
          this.express_details_one.splice(1);
          this.express_details_three.splice(1);
        }
      },
    },
    choosedCities: {
      deep: true,
      handler() {
        this.selection = this.choosedCities;
      },
    },
    confirmLeave: {
      deep: true,
      handler() {
        if (this.confirmLeave) {
          if (this.toPage.path.startsWith("/material-order-rules")) {
            this.$router.replace("/material-order-rules?type=" + this.ruleType);
          } else {
            this.$router.replace(this.toPage.path);
          }
        }
      },
    },
    toEdit: {
      handler() {
        if (this.toEdit) {
          this.$router.replace({
            path: this.$route.path,
            query: { type: this.order_rule.type, mode: "edit" },
          });
          this.mode = "edit";
        }
      },
    },
    freeFlag: {
      handler() {
        if (this.freeFlag == 0) {
          this.conditions.free_money = null;
        }
      },
    },
  },
  beforeRouteLeave(to, from, next) {
    // 导航离开该组件的对应路由时调用
    // 可以访问组件实例 `this`
    if (!this.order_rule.status && !this.isNew) {
      this.toPage = to;
      if (this.confirmLeave) {
        next();
      } else if (!this.toEdit) {
        this.isLeaveDialog = true;
        this.alertMessage = i18n.t(
          "MaterialOrderRule.Messages.isLeaveALertMsg"
        );
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
};
</script>